var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import WixComponent from '../BaseComponents/WixComponent';
import classnames from 'classnames';
import { node, oneOf, string } from 'prop-types';

import typography, { convertFromUxLangToCss } from '../Typography';
import badgeStyles from './Badge.scss';

/**
 * General purpose badge component to indicate important (or not so) things
 */

var Badge = function (_WixComponent) {
  _inherits(Badge, _WixComponent);

  function Badge(props) {
    _classCallCheck(this, Badge);

    var _this = _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).call(this, props));

    _this.setStyles(badgeStyles, typography);
    return _this;
  }

  _createClass(Badge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          type = _props.type,
          appearance = _props.appearance,
          alignment = _props.alignment,
          shape = _props.shape,
          dataHook = _props.dataHook;
      var styles = this.styles,
          typography = this.typography;

      var className = classnames(styles.badge, styles[type], styles[alignment], styles[shape], typography[convertFromUxLangToCss(appearance)]);

      return React.createElement(
        'span',
        { className: className, 'data-hook': dataHook },
        children
      );
    }
  }]);

  return Badge;
}(WixComponent);

Badge.propTypes = {
  /** node to render into badge */
  children: node.isRequired,

  /** define purpose of a badge, different color for each type */
  type: oneOf(['default', 'primary', 'success', 'info', 'warning', 'danger']),

  /** set `vertical-align` */
  alignment: oneOf(['top', 'bottom', 'middle']),

  /** choose appearance of typography. For Typography examples see storybook **Common** -> **Typography** */
  appearance: oneOf(['H0', 'H1', 'H2', 'H2.1', 'H3', 'H4', 'T1', 'T1.1', 'T1.2', 'T1.3', 'T1.4', 'T2', 'T2.1', 'T2.2', 'T2.3', 'T3', 'T3.1', 'T3.2', 'T3.3', 'T3.4', 'T4', 'T4.1', 'T4.2', 'T4.3', 'T5', 'T5.1']),

  /** set the shape */
  shape: oneOf(['ellipse', 'rectangle']),

  /** set one to find component in testing environment */
  dataHook: string
};

Badge.defaultProps = {
  type: 'default',
  appearance: 'H4',
  alignment: 'middle',
  shape: 'ellipse'
};

Badge.displayName = 'Badge';

export default Badge;
//# sourceMappingURL=Badge.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Badge/Badge.js